import { Request,BaseApiUrl } from "./api";
//客户管理模块
// 列表
export const getConsultPriceListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/ConsultPrice/get`, { params: params });
};
//编辑
export const editConsultPrice = (params) => {
  return Request.post(`${BaseApiUrl}/api/ConsultPrice/put`, params);
};
//新增
export const addConsultPrice = (params) => {
  return Request.post(`${BaseApiUrl}/api/ConsultPrice/post`, params);
};

// 获取添加报价单的所有强度等级模型
export const getConsultPriceBaseData = (params) => {
  return Request.get(`${BaseApiUrl}/api/ConsultPrice/GetConsultPriceBaseData`, { params: params });
};

//批量删除
export const batchDeleteConsultPrice = (params) => {
  return Request.post(`${BaseApiUrl}/api/ConsultPrice/BatchDelete`, params);
};

// export const batchDeleteConsultPrice = (params) => {
//   return Request.delete(`${BaseApiUrl}/api/ConsultPrice/BatchDelete`, {
//     data: params,
//     headers: {
//       "Content-Type": "application/json-patch+json",
//     },
//   });
// };
// 历史列表
export const getHistryByPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/ConsultPrice/GetHistry`, { params: params });
};